import { render } from "./adminToastMessage.vue?vue&type=template&id=a098f3d4"
import script from "./adminToastMessage.vue?vue&type=script&lang=js"
export * from "./adminToastMessage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__